// Full screen on a desktop (26 Oct 2026): the whole page, through the browser's Fullscreen API. Nothing where the
// browser has no such API (iPhone Safari, some in-app browsers). Esc or the same button leaves it.
import { useEffect, useState } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';

const supported = () => typeof document !== 'undefined' && document.fullscreenEnabled === true && typeof document.documentElement.requestFullscreen === 'function';

export function FullScreenButton() {
  const [on, setOn] = useState(() => typeof document !== 'undefined' && Boolean(document.fullscreenElement));
  useEffect(() => {
    const sync = () => setOn(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', sync);
    return () => document.removeEventListener('fullscreenchange', sync);
  }, []);
  if (!supported()) return null;
  const toggle = () => {
    try {
      const p = document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen();
      p?.catch?.(() => undefined);
    } catch { /* some in-app browsers refuse at once */ }
  };
  const Icon = on ? Minimize2 : Maximize2;
  return (
    <button type="button" onClick={toggle} data-part="full-screen"
      className="inline-flex min-h-11 items-center gap-1.5 rounded-[10px] px-2 text-sm font-semibold">
      <Icon className="size-4" strokeWidth={2.6} aria-hidden="true" />
      {on ? 'Exit full screen' : 'Full screen'}
    </button>
  );
}
